module.exports = __webpack_public_path__ + "img/syukyaku-kyu-002.cef407ed.jpg";